import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from '../components/GeneratePdf';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

let totalQuestions = 0;

const QuestionDetails = () => {
    const authorizedAxios = generateAxiosInstance()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const isApiCall = useRef(false);
    const [examList, setExamList] = useState([])
    const [questionBankType, setQuestionBankType] = useState('');
    const [gradeMasterId, setGradeMasterId] = useState("");
    const [grades, setGrades] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [syllabusSort, setSyllabusSort] = useState(null);
    const [textBookSubjectSort, setTextBookSubjectSort] = useState(null);
    const [textBookQuestionSort, setTextBookQuestionSort] = useState(null);

    const [subjectSort, setSubjectSort] = useState(null);
    const [authoritySort, setAuthoritySort] = useState(null);
    const [examNameSort, setExamNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [questionSort, setQuestionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);

    const searchKeysTextBook = [
        "syllabusStructureMasterDetails.syllabusStructureName",
        "streamOrMediumMasterDetails.streamName",
        "boardMasterDetails.boardName",
        "gradeMasterDetails.gradeName",
        "subjectMasterDetails.subjectName",
        "questionCount"
    ];

    const searchKeysCompetitive = [
        "competitiveExamNameMasterDetails.gradeMasterDetails.gradeName",
        "examName",
        "competitiveExamBookMasterDetails.bookName",
        "competitiveExamNameMasterSubjectDetails.subjectMasterDetails.subjectName",
        "examQuestionCount"
    ];

    const searchKeysCompetitiveSubjectWise = [
        "gradeMasterDetails.gradeName",
        "competitiveExamNameMasterDetails.examName",
        "competitiveExamBookMasterDetails.bookName",
        "competitiveExamNameMasterSubjectDetails.subjectName",
        "questionCount"
    ];


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const getGrade = () => {
        const apiUrl = `/get-grade-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setGrades(response.data.result);
            })
            .catch(error => {
                setGrades([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setQuestionBankType(e.target.value);
        isApiCall.current = false;

        setGradeMasterId("");
        if (grades.length == 0) getGrade();

        // setCurrPage(1);
        if (examList.length > 0) {
            setExamList([]);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getQuestionDetails();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (questionBankType && questionBankType.length !== "") {
                setCurrPage(1);
                // Construct the API URL when syllabusData changes
                let apiUrl = `/question-bank-report?type=${questionBankType}`;

                if (gradeMasterId) {
                    apiUrl += `&gradeMasterId=${gradeMasterId}`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setExamList(await searchArray("A", apiUrl, questionBankType === "1" ? searchKeysTextBook : questionBankType === "2" ? searchKeysCompetitive : searchKeysCompetitiveSubjectWise, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        setTotalPages(Math.ceil(examList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > examList.length) {
            endIndex = examList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(examList.slice(startIndex, endIndex));
    }, [examList, currPage, itemsPerPage]);

    useEffect(() => {
        if (questionBankType !== '') {
            setError('')
        }
    }, [questionBankType])

    const getQuestionDetails = () => {
        if (questionBankType != '') {
            setLoading(true);
            let apiUrl = `/question-bank-report?type=${questionBankType}`;
            if (gradeMasterId) {
                apiUrl += `&gradeMasterId=${gradeMasterId}`;
            }
            apiUrl = apiUrl.replace(/&$/, '');

            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setExamList(response.data.data);

                    setBoardSort(null);
                    setMediumSort(null);
                    setSyllabusSort(null);
                    setTextBookSubjectSort(null);
                    setTextBookQuestionSort(null);

                    setSubjectSort(null);
                    setExamNameSort(null);
                    setBookNameSort(null);
                    setQuestionSort(null);

                    setCurrPage(1);

                    if (isApiCall.current === false) isApiCall.current = true;
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            setError("This field is required")
        }
    }

    const handleInputReset = () => {
        setQuestionBankType('');
        setGradeMasterId("");
        setExamList([]);
        setError('');

        setBoardSort(null);
        setMediumSort(null);
        setSyllabusSort(null);
        setTextBookSubjectSort(null);
        setTextBookQuestionSort(null);

        setSubjectSort(null);
        // setAuthoritySort(null);
        setExamNameSort(null);
        setBookNameSort(null);
        setQuestionSort(null);

        setCurrPage(1);
        isApiCall.current = false;
    }

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setMediumSort(null);
            setSyllabusSort(null);
            setTextBookSubjectSort(null);
            setTextBookQuestionSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setBoardSort(null);
            setSyllabusSort(null);
            setTextBookSubjectSort(null);
            setTextBookQuestionSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (syllabusSort == true || syllabusSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setTextBookSubjectSort(null);
            setTextBookQuestionSort(null);
        }
    }, [syllabusSort])

    useEffect(() => {
        if (textBookSubjectSort == true || textBookSubjectSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusSort(null);
            setTextBookQuestionSort(null);
        }
    }, [textBookSubjectSort])

    useEffect(() => {
        if (textBookQuestionSort == true || textBookQuestionSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusSort(null);
            setTextBookSubjectSort(null);
        }
    }, [textBookQuestionSort])


    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            // setAuthoritySort(null);
            setExamNameSort(null);
            setBookNameSort(null);
            setQuestionSort(null);
        }
    }, [subjectSort])

    // useEffect(() => {
    //     if (authoritySort == true || authoritySort == false) {
    //         setSubjectSort(null);
    //         setExamNameSort(null);
    //         setBookNameSort(null);
    //         setQuestionSort(null);
    //     }
    // }, [authoritySort])

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setSubjectSort(null);
            // setAuthoritySort(null);
            setBookNameSort(null);
            setQuestionSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setSubjectSort(null);
            // setAuthoritySort(null);
            setExamNameSort(null);
            setQuestionSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (questionSort == true || questionSort == false) {
            setSubjectSort(null);
            // setAuthoritySort(null);
            setExamNameSort(null);
            setBookNameSort(null);
        }
    }, [questionSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Question Details</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-question-circle"></i>Question Details</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Question Bank Type:</label>
                                                    <select class="form-select" aria-label="Default select example" name='questionBankType' onChange={handleInputChange} value={questionBankType}>
                                                        <option value={''} disabled>Select Question Bank Type</option>
                                                        <option value={"1"}>Text Book Exam</option>
                                                        <option value={"2"}>Competitive Exam</option>
                                                        <option value={"3"}>Competitive Exam Subject Wise</option>
                                                    </select>
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="gradeMasterId" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeMasterId' onChange={(e) => setGradeMasterId(e.target.value)} value={gradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            questionBankType && grades.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={getQuestionDetails}>Show</button>
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                {isApiCall.current && questionBankType === "1" && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        {examList && examList.length > 0 && <GeneratePdf id="adminQuestionDetails" title={"Question Bank Details (Text Book)"} />}
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div id='adminQuestionDetails'>
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">

                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Syllabus Structure
                                                                                <SortIcon sortState={syllabusSort} setSortState={setSyllabusSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"syllabusStructureMasterDetails.syllabusStructureName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Medium
                                                                                <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"streamOrMediumMasterDetails.streamName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Board
                                                                                <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"boardMasterDetails.boardName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Class
                                                                            </th>
                                                                            <th scope="col">
                                                                                Subject
                                                                                <SortIcon sortState={textBookSubjectSort} setSortState={setTextBookSubjectSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Total Question
                                                                                <SortIcon sortState={textBookQuestionSort} setSortState={setTextBookQuestionSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"questionCount"} />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData.length > 0 ?
                                                                                displayedData.map((exam, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{exam?.syllabusStructureMasterDetails?.syllabusStructureName}</td>
                                                                                            <td>{exam?.streamOrMediumMasterDetails?.streamName}</td>
                                                                                            <td>{exam?.boardMasterDetails?.boardName}</td>
                                                                                            <td>{exam?.gradeMasterDetails?.gradeName}</td>
                                                                                            <td>{exam?.subjectMasterDetails?.subjectName}</td>
                                                                                            <td>{exam?.questionCount}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Question Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>

                                                                {examList && <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={examList.length} />}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}


                                                {isApiCall.current && questionBankType === "2" && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        {examList && examList.length > 0 && <GeneratePdf id="adminQuestionDetails" title={"Question Bank Details (Competitive)"} />}
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div id='adminQuestionDetails'>
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">

                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">Class</th>
                                                                            {/* <th scope="col">
                                                                                Authority/Board
                                                                                <SortIcon sortState={authoritySort} setSortState={setAuthoritySort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"authorityName"} />
                                                                            </th> */}
                                                                            <th scope="col">
                                                                                Exam Name
                                                                                <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"examName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Book Name
                                                                                <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.bookName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Subject
                                                                                <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterSubjectDetails.subjectMasterDetails.subjectName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Total Question
                                                                                <SortIcon sortState={questionSort} setSortState={setQuestionSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"examQuestionCount"} />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData.length > 0 ?
                                                                                displayedData.map((exam, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{exam?.competitiveExamNameMasterDetails?.map((i) => i.gradeMasterDetails?.gradeName).join(', ')}</td>
                                                                                            {/* <td>{exam?.authorityName}</td> */}
                                                                                            <td>{exam?.examName}</td>
                                                                                            <td>{exam?.competitiveExamBookMasterDetails?.map((i) => i.bookName).join(', ')}</td>
                                                                                            <td>{exam?.competitiveExamNameMasterSubjectDetails?.map((i) => i.subjectMasterDetails?.subjectName).join(', ')}</td>
                                                                                            <td>{exam?.examQuestionCount}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Question Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>

                                                                {examList && <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={examList.length} />}


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}

                                                {isApiCall.current && questionBankType === "3" && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        {examList && examList.length > 0 && <GeneratePdf id="adminSubjectQuestionDetails" /*title={"Question Bank Details (Competitive) Subject Wise"}*/ title={examList} headerTitle={"Competitive Exam Data Sheet"} />}
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div id='adminSubjectQuestionDetails'>
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">

                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">Class</th>
                                                                            <th scope="col">
                                                                                Exam Name
                                                                                <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.examName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Book Name
                                                                                <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.bookName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Subject
                                                                                <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterSubjectDetails.subjectName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Total Question
                                                                                <SortIcon sortState={questionSort} setSortState={setQuestionSort} setData={setExamList} setCurrPage={setCurrPage} sortingPath={"questionCount"} />
                                                                            </th>
                                                                            <th scope="col">Last Updated</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData.length > 0 ?
                                                                                displayedData.map((exam, index) => {
                                                                                    const isLast = index === displayedData.length - 1;
                                                                                    return (
                                                                                        <>
                                                                                            <tr>
                                                                                                <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                                <td>{exam?.gradeMasterDetails?.gradeName}</td>
                                                                                                <td>{exam?.competitiveExamNameMasterDetails?.examName}</td>
                                                                                                <td>{exam?.competitiveExamBookMasterDetails?.bookName}</td>
                                                                                                <td>{exam?.competitiveExamNameMasterSubjectDetails?.subjectName}</td>
                                                                                                <td>{exam?.questionCount}</td>
                                                                                                <td>{exam?.lastQuestionUpdatedDate}</td>
                                                                                            </tr>
                                                                                            {isLast && (
                                                                                                <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                                                                                    {/* <td colSpan="5" style={{ textAlign: 'center' }}>Total Questions</td> */}
                                                                                                    {/* <td></td> */}
                                                                                                    <td colSpan={"2"}>Total Class: {new Set(displayedData.map(exam => exam?.gradeMasterDetails?.id)).size}</td>
                                                                                                    <td>Total Exam Name: {new Set(displayedData.map(exam => exam?.competitiveExamNameMasterDetails?.id)).size}</td>
                                                                                                    <td>Total Exam Book: {new Set(displayedData.map(exam => exam?.competitiveExamBookMasterDetails?.id)).size}</td>
                                                                                                    <td>Total Subject: {new Set(displayedData.map(exam => exam?.competitiveExamNameMasterSubjectDetails?.id)).size}</td>
                                                                                                    <td>Total Questions: {displayedData.reduce((sum, exam) => sum + (Number(exam?.questionCount) || 0), 0)}</td>
                                                                                                    <td></td>
                                                                                                </tr>
                                                                                            )}
                                                                                        </>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Question Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>

                                                                {examList && <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={examList.length} />}


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default QuestionDetails;